import { useMutation, useQueryClient } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { API_ALLERGY_LOG } from 'services/dataService/ccmResources';
import { showResult } from 'infrastructure/hooks/utils';

import { ALLERGY_KEY } from './use-get-allergy-logs';

import type { IAllergyLog, IAddAllergyLog } from 'infrastructure/interfaces';

const addAllergyLogFn = async (postData: IAddAllergyLog) => {
  const url = API_ALLERGY_LOG;
  const { error, data } = await dataService.createOne<IAllergyLog>(
    url,
    postData,
  );

  if (error) {
    showResult(error);
    throw new Error(error);
  }

  return data;
};

export const useAddAllergyLog = () => {
  const queryClient = useQueryClient();
  const { mutate, isLoading, ...other } = useMutation({
    mutationFn: async (postData: IAddAllergyLog) => addAllergyLogFn(postData),
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: [ALLERGY_KEY] });
      showResult();
    },
  });
  return {
    addAllergyLog: mutate,
    addLoading: isLoading,
    ...other,
  };
};
